import { render } from "./Home.vue?vue&type=template&id=9ba8d08c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=9ba8d08c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3963854441/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba8d08c"]])

export default __exports__